// extracted by mini-css-extract-plugin
export var container = "framed-text-module--container--b6f23";
export var content = "framed-text-module--content--f6a05";
export var image = "framed-text-module--image--7f71f";
export var imageContainer = "framed-text-module--imageContainer--ddab9";
export var text = "framed-text-module--text--24473";
export var textContent = "framed-text-module--textContent--d152d";
export var title = "framed-text-module--title--14637";